import styled from "styled-components";

export const Container = styled.div`
  display: block;
  margin: 0 auto;
  max-width: 900px;
  @media (max-width: 430px) {
    margin-left: 10px;
  }
`;
export const H1 = styled.h1`
  font-family: Cormorant Infant;
  font-size: 60px;
  font-weight: 500;
  text-align: center;
`;
export const HeaderText = styled.div`
  font-family: Cormorant Infant;
  font-size: 35px;
  font-weight: 500;
  text-align: left;
  margin: 40px 0px 30px 0px;
`;
export const MainText = styled.div`
  display: block;
  align-items: center;
`;

export const Br = styled.div`
  height: 10px;
`;

export const Ul = styled.ul`
  margin-left: 25px;
  margin-bottom: 10px;
`;
